<div class="lum-invoice-skus-table">
  <form [formGroup]="form">
    <lum-rfq-table-form
      [form]="form"
      [searchableFields]="searchableFields"
      [searchStr]="searchStr"
      [rfqs]="rfqs"
      [columns]="columns"
      [loadingRfqs]="loadingRfqs"
      [fromEnterEvent]="fromEnterEvent"
      [isSalesOrderShippedStatus]="isSalesOrderShippedStatus"
      [isInvoiceStatusComplete]="isInvoiceStatusComplete"
      [fromInvoice]="true"
      (removeLineItem)="removeLineItem.emit($event)"
      (addRowItems)="addRowItems.emit($event)"
      (addRowItemSubTotal)="addRowItemSubTotal.emit($event)"
      (searchRfq)="searchRfq.emit($event)"
      (enterRfqEvent)="enterRfqEvent.emit($event)"
      (selectRfq)="selectRfq.emit($event)"
      (scrollPaginate)="scrollPaginate.emit($event)"
      (recalculateSubtotals)="recalculateSubtotals.emit()"
    ></lum-rfq-table-form>

    <div class="lum-invoice-skus-table__summary mt-4">
      <div class="flex flex-column">
        <div class="flex justify-end mb-4">
          <div class="flex gap-4 pb-2 pr-2 pl-2 table__summary-section">
            <div class="flex w-100 justify-end table__summary-label-tax">
              Total Units
            </div>
            <div class="flex w-100 justify-end">
              <b>{{ totalUnits | decimalPlaces }}</b>
            </div>
          </div>
        </div>
        <div class="flex justify-end mb-2">
          <div class="flex gap-4 pb-2 pr-2 pl-2 table__summary-section">
            <button
              type="button"
              class="
                table__summary-label-shipping lum-u-reset flex gap-2 w-100 justify-end cursor-pointer
              "
              (click)="onOpenShippingRatesDialog()"
            >
              <lum-ui-icon
                icon="shipping"
                [width]="16"
                [height]="16"
                color="#5563d6"
              ></lum-ui-icon>
              Shipping
            </button>
            <div class="flex w-100 justify-end">
              <input
                formControlName="shipping_amount"
                type="number"
                inputmode="numeric"
                class="lum-input text-right w-25"
                matInput
                [readonly]="isInvoiceStatusComplete"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-end mb-4">
          <div class="flex gap-4 pb-2 pr-2 pl-2 table__summary-section">
            <div class="flex w-100 justify-end table__summary-label-tax"> Tax </div>
            <div class="flex w-100 justify-end">
              <input
                formControlName="tax_amount"
                type="number"
                inputmode="numeric"
                class="lum-input text-right w-25"
                matInput
                [readonly]="isInvoiceStatusComplete"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-end mb-4">
          <div class="flex pb-2 pr-2 pl-2 table__summary-section">
            <div class="flex w-100 justify-end table__summary-label">
              Sub Total
            </div>
            <div class="flex w-100 justify-end">
              <b>{{ subTotal | currency }}</b>
            </div>
          </div>
        </div>

        <div class="flex justify-end mb-4">
          <div class="flex pb-2 pr-2 pl-2 table__summary-section">
            <div class="flex w-100 justify-end table__summary-label">
              Total Discount
            </div>
            <div class="flex w-100 justify-end">
              <b>{{ totalDiscount | currency }}</b>
            </div>
          </div>
        </div>

        <!-- NEW CREDIT MEMO ENTRIES START -->
        <div formArrayName="creditMemoEntries">
          <div class="flex justify-end mb-4">
            <div class="flex pb-2 pr-2 pl-2 table__summary-section">
              <div class="flex w-100 justify-end table__summary-label pr-8">
                <lum-ui-icon
                  *ngIf="!isEditInvoice"
                  class="cursor-pointer pr-2"
                  width="10"
                  height="10"
                  icon="add-circle"
                  color="#5563d6"
                  (click)="
                    !isInvoiceStatusComplete && onAddInvoiceCreditMemoEntry()
                  "
                  [ngClass]="{ 'no-cursor-pointer': isInvoiceStatusComplete }"
                ></lum-ui-icon>
                Credit Memo Entry
              </div>
            </div>
          </div>
          <div
            class="flex justify-end"
            *ngFor="
              let invoiceCreditMemo of invoiceCreditMemoFormArray.controls;
              trackBy: trackByControlValue;
              let i = index
            "
            [formGroupName]="i"
          >
            <div class="flex justify-end mb-4">
              <div class="flex w-100 justify-end pr-2 pt-3" *ngIf="!isEditInvoice">
                <mat-checkbox
                  class="lum-checkbox"
                  formControlName="applyCreditMemoEntry"
                ></mat-checkbox>
              </div>
              <div class="flex w-100 justify-end pr-2">
                <input
                  [debounceTime]="1000"
                  [matAutocomplete]="auto"
                  [readonly]="
                    invoiceCreditMemo.value?.applyCreditMemoEntry ||
                    invoiceCreditMemo.value?.disable ||
                    isInvoiceStatusComplete
                  "
                  (input)="onSearchCreditMemo($event)"
                  class="lum-input text-right w-30"
                  formControlName="creditMemo"
                  placeholder="Search Label..."
                  type="text"
                  matInput
                  lumDebounceTime
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayFnCreditMemo"
                  (optionSelected)="onSelectCreditMemo($event, i)"
                >
                  <mat-option
                    *ngFor="
                      let creditMemo of filteredCreditMemos;
                      trackBy: trackById
                    "
                    [value]="creditMemo"
                  >
                    <strong>{{ creditMemo?.label }} </strong>
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="flex w-100 justify-end">
                <input
                  [ngClass]="{
                    'text-red':
                      invoiceCreditMemo.value?.creditMemo?.balanceAmount <
                        invoiceCreditMemo?.value?.amount ||
                      invoiceCreditMemo?.value?.amount <= 0,
                  }"
                  [readonly]="
                    invoiceCreditMemo.value?.disable || isInvoiceStatusComplete
                  "
                  formControlName="amount"
                  type="number"
                  inputmode="numeric"
                  class="lum-input text-right w-30"
                  matInput
                  lumDebounceTime
                  lumDecimalLimit
                />
              </div>
              <div class="flex w-100 justify-end" *ngIf="!isEditInvoice">
                <button
                  mat-icon-button
                  (click)="onRemoveCreditMemoEntry(i)"
                  [disabled]="isInvoiceStatusComplete"
                >
                  <lum-ui-icon
                    icon="delete-bin"
                    [width]="16"
                    [height]="16"
                    color="#f24f63"
                  ></lum-ui-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- NEW CREDIT MEMO ENTRIES END -->

        <div class="flex justify-end">
          <div class="flex pb-2 pr-2 pl-2 table__summary-section">
            <div class="flex w-100 justify-end table__summary-label">
              <a class="pr-1" (click)="toggleCreditMemoNote()"
                ><i
                  *ngIf="invoiceCreditMemoFormArray.controls.length > 0"
                  class="fa fa-exclamation-circle text-yellow-400"
                ></i
              ></a>
              Net Total
            </div>
            <div class="flex w-100 justify-end">
              <b>{{ netTotal | currency }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
